import React, { FC, useCallback, useMemo } from 'react';

import WorkspaceFields from '../../WorkspaceFields';
import ControlBtns from './ControlBtns';
import {
  WORKSPACE_ACTIONS,
  workspaceNameCreateInitialValues,
  workspaceNameEditInitialValues,
  workspaceNameFields
} from 'src/constants/workspacesConstants';
import { workspaceNameValidationSchema } from 'src/helpers/workspacesHelpers';

type TChangeNameActionProps = {
  action: WORKSPACE_ACTIONS;
  onClose: () => void;
  onConfirm: (value: { name: string }) => void;
  nameValue?: string;
};

const ChangeNameAction: FC<TChangeNameActionProps> = ({ onClose, onConfirm, nameValue, action }) => {
  const onSubmit = useCallback(
    (values: { name: string }) => {
      onConfirm(values);
    },
    [onConfirm]
  );

  const workspaceNameInitialValues = useMemo(() => {
    if (action === WORKSPACE_ACTIONS.EDIT_WORKSPACE && nameValue) {
      return workspaceNameEditInitialValues(nameValue);
    }

    return workspaceNameCreateInitialValues;
  }, [action, nameValue]);

  return (
    <WorkspaceFields
      onSubmit={onSubmit}
      initialValues={workspaceNameInitialValues}
      schema={workspaceNameValidationSchema}
      fileds={workspaceNameFields}
      size="sm"
      actionBtn={({ isDisabled }) => (
        <ControlBtns onClose={onClose} isDisabledConfirm={isDisabled} buttonType="submit" />
      )}
    />
  );
};

export default ChangeNameAction;
